// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"BK-z","carouselContainer":"CK-z"};